import * as Scrivito from "scrivito"

export const AccordionFeatureWidget = Scrivito.provideWidgetClass(
  "AccordionFeatureWidget",
  {
    attributes: {
      headline: ["widgetlist", { only: "TextWidget", maximum: 1 }],
      text: ["widgetlist", { only: "TextWidget", maximum: 1 }],
      accordion: ["widgetlist", { only: "AccordionWidget", maximum: 1 }],
      cta: ["widgetlist", { only: "ButtonWidget", maximum: 1 }],
      alternativeBackground: "boolean"
    }
  }
)
